module.exports = __webpack_public_path__ + "static/media/dungeon.e9225f66.jpeg";